/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { additionalUploadsPostRequestSchema } from './additionalUploadsPostRequestSchema.ts';
import { additionalUploadsPostResponseSchema } from './additionalUploadsPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postAdditionalUploads200Schema = z.lazy(() => additionalUploadsPostResponseSchema);

/**
 * @description 505 response
 */
export const postAdditionalUploads505Schema = z.any();

export const postAdditionalUploadsMutationRequestSchema = z.lazy(() => additionalUploadsPostRequestSchema);

export const postAdditionalUploadsMutationResponseSchema = z.lazy(() => postAdditionalUploads200Schema);
